import { render, staticRenderFns } from "./NewLoteAnimal.vue?vue&type=template&id=0276258c&scoped=true"
import script from "./NewLoteAnimal.vue?vue&type=script&lang=js"
export * from "./NewLoteAnimal.vue?vue&type=script&lang=js"
import style0 from "./NewLoteAnimal.vue?vue&type=style&index=0&id=0276258c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276258c",
  null
  
)

export default component.exports